<template>
    <div class="fourthView">
        <div class="dec mainCont">
            <div class="background-image">
                <div class="text-content">
                <p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">鲸蜗家政管理有限公司成立于2003年，总部位于江西九江瑞昌市赛湖农商大</p>
				<p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px;  ">厦，作为020数字化家庭服务企业，为广大民众以卓越的服务品质、专业安全</p>
				<p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">的技术服务实力，提供家电维修、清洗、管道疏通、家庭保洁、其他商业型等</p>
				<p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">多元化生活服务。</p>
				<div style="height: 40px;"></div>
				<p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">成立数十年来,鲸蜗家政始终坚持诚信立业、阳光服务、价格透明的经营原则，</p>
				<p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">工程师经验丰富、技术专业。通过提供个性化服务，满足不同家庭的需求，</p>
				<p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px;  ">让每个家庭都能享受到贴心、舒心的生活环境。</p>
				<div style="height: 40px;"></div>
                <p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">2019年通过高质量的家庭服务管理体系认证,先后获得"江西电子商务创新</p>
				<p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">奖"、"AAA级信用单位""2022年中国品牌创新奖""江西电子商务示范</p>
				<p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">企业"等荣誉,并与电信运营商、物业、房地产、电器厂家、高德地图、百度</p>
                <p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">等知名企业建立了合作关系。</p>
				<div style="height: 40px;"></div>	
				<p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">覆盖逾280主要家电和家居类别，包括家电维修、家电安装、家电清洗、管道</p>
				<p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">疏通、家电回收、保洁清洗、水电维修、防水补漏、瓷砖地板等;为全国多个</p>
				<p style="text-align: left;margin-left: 50px;font-weight: bold; font-size: 17px; ">城市的上千万个中国家庭提供专业、安全、放心、贴心的服务。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import {getArtice} from '@/api/api'
	import {formatRichText} from "@/utils/utils"
	export default {
		name: 'fourthView',
		components: {},
		data() {
			return {
				articeObj:{},
				content:'',
			};
		},
		mounted() {
			this.getArtice();
		},
		methods: {
			// 企业简介
			getArtice(){
				getArtice({type:'8'}).then(res => {
					this.articeObj = res.data;
					this.content = formatRichText(res.data.content)
				})
			},
		},
	};
</script>

<style lang="scss" scoped>
	// .fourthView {padding: 24px 0 50px;
	// 	.box{
	// 		.imgs{display: flex;align-items: center;flex-wrap: wrap;
	// 			.big{width: 66%;margin-bottom: 24px;}
	// 			.sml{width: 32%;margin-bottom: 24px;}
	// 			.mr{margin-right: 2%;}
	// 		}
	// 		p{color: #1F263F;font-size: 16px;line-height: 28px;margin-bottom: 30px;}
	// 	}
		// .dec{color: #1F263F;font-size: 16px;margin-bottom: 26px;line-height: 30px;
		// 	p{color: #1F263F;font-size: 16px;margin-bottom: 26px;line-height: 30px;
		// 		&:last-child{margin-bottom: 0;}
		// 	}
		// }
		
	// }
 .fourthView {
        width: 100%; /* 使容器宽度自适应 */
        // overflow: hidden; /* 防止溢出 */
		overflow: visible; /* 允许背景图超出容器边界 */
    }
    .dec.mainCont {
        position: relative; /* 使子元素绝对定位相对于此元素 */
    }
    .background-image {
        background-image: url('https://jwocx.com/2024/08/07/B29A48C84CA0A9A9A5F7A122BCE01FDC.png');
        background-size: contain; /* 背景图保持比例并适应容器 */
        background-repeat: no-repeat; /* 不重复背景图 */
        background-position: center top; /* 背景图从顶部居中显示 */
        padding: 1260px 40px; /* 内边距，确保文字不贴边 */
         color: black; /* 文字颜色改为黑色 */
        height: 100vh; /* 设置容器高度为视口高度 */
        display: flex; /* 使用flexbox布局 */
        align-items: flex-start;; /* 垂直居中对齐文字 */
        justify-content: center; /* 水平居中对齐文字 */
        text-align: center; /* 文字居中 */
    }
 .text-content {
        position: relative; /* 确保文字在背景图上方 */
        z-index: 1; /* 确保文字在背景图之上 */
        max-width: 1200%; /* 限制文本的最大宽度 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 超出部分用省略号表示 */
        white-space: nowrap; /* 不换行 */
		  letter-spacing: 7px; /* 增加字母间距 */
        line-height: 2.5; /* 增加行间距 */
    }
 
</style>




// WEBPACK FOOTER //
// src/views/aboutUs/components/fourthView.vue